import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MatLine } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';

import { Store } from '@ngrx/store';
import { HomeSelectors } from 'projects/semeris/src/store/home/home.selectors';
import { HomeState } from 'projects/semeris/src/store/home/home.state';
import { Observable } from 'rxjs';

import { ProductUpdate } from '../../../home/models/product-update.model';
import { DateFormatPipe } from '../../../shared/pipes/date-format.pipe';
import { SafeHtmlPipe } from '../../../shared/pipes/safe-html.pipe';

export const HELP_ID_PRODUCT_UPDATES = 'product-updates.html';

@Component({
  selector: 'semeris-help-product-updates',
  templateUrl: './help-product-updates.component.html',
  styleUrls: ['./help-product-updates.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, MatLine, SafeHtmlPipe, DateFormatPipe, AsyncPipe],
})
export class HelpProductUpdatesComponent implements OnInit {
  private readonly store = inject<Store<HomeState>>(Store);

  public productUpdates$: Observable<ProductUpdate[]>;

  public ngOnInit(): void {
    this.productUpdates$ = this.store.select(HomeSelectors.productUpdates);
  }
}
